import { ArrowsRightLeftIcon } from '@heroicons/react/24/outline';
import Button from 'components/Buttons/Button';
import { Menu } from 'components/Menu';
import { useUserRoles } from 'containers/App/context/useUserRoles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import 'twin.macro';

export function SwitchUserRoleMenuItem() {
  const { hasRoleDirector, hasRoleTeacher } = useUserRoles();
  const { pathname } = useLocation();
  const enableSwitchToDirector =
    hasRoleDirector && !pathname.includes('direction');
  const enableSwitchToTeacher =
    hasRoleTeacher && pathname.includes('direction');
  const { t } = useTranslation(['common']);
  const navigate = useNavigate();

  return (
    <>
      {enableSwitchToDirector && (
        <Menu.Item>
          <Button
            intent="primary"
            tw="whitespace-nowrap rounded-none font-medium"
            onClick={() => {
              navigate('/direction/settings/account');
            }}
            aria-label="menu profile aller sur la vue directeur"
            minimal
            fill
            alignText="left"
            large
            icon={ArrowsRightLeftIcon}
          >
            {t('common:directorAccount')}
          </Button>
        </Menu.Item>
      )}
      {enableSwitchToTeacher && (
        <Menu.Item>
          <Button
            intent="primary"
            tw="whitespace-nowrap rounded-none font-medium"
            onClick={() => {
              navigate('/dashboard');
            }}
            aria-label="menu profile aller sur la vue enseignant"
            minimal
            fill
            alignText="left"
            large
            icon={ArrowsRightLeftIcon}
          >
            {t('common:teacherAccount')}
          </Button>
        </Menu.Item>
      )}
    </>
  );
}
